<template>
  <el-button v-permission="'can_change_cooperation'" class="funcbars-button" size="mini" @click="handleClick">
    <i class="el-icon-right"/>转{{ cooperation_new }}
  </el-button>
</template>
<script>
import {changeCooperation} from "../../../../api/order";

export default {
  name: 'ChangeCooperation',
  props: {
    selection: {
      type: Array,
      default() {
        return []
      }
    },
    cooperation: {
      type: String,
      required: true
    }
  },
  computed: {
    cooperation_new() {
      return this.cooperation === '年框大全案' ? '全案营销' : '年框大全案'
    }
  },
  methods: {
    handleClick: function () {
      const len = this.selection.length
      if (!len) {
        this.$message.warning('请先选择行数据')
        return;
      }
      let dom = `<h3>已选中${len}行：</h3>`
      const ids = this.selection.map(_ => {
        dom += `<div>${_.order_no}</div>`
        return _.id
      })
      this.$confirm(
          dom,
          `确认转移到${this.cooperation_new}吗？`,
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(async () => {
            const response = await changeCooperation({
              ids,
              old_cooperation: this.cooperation,
              new_cooperation: this.cooperation_new === '全案营销' ? '红人全案' : this.cooperation_new
            })
            if (!response.success) {
              this.showToast({h: this, icon: "el-icon-error", text: response.message, duration: 3000});
              return;
            }
            this.showToast({h: this, icon: "el-icon-success", text: '操作成功', duration: 2000});
            this.$emit('success')
          })
    }
  }
}
</script>
<style scoped>

</style>
